import axios from "./api";
class PreselectionService {
  getAll() {
    return axios.get(`/preselections`);
  }
  get(id) {
    return axios.get(`/preselections/${id}`);
  }
  create(data) {
    return axios.post(`/preselections`, data);
  }
  update(id, data) {
    return axios.put(`/preselections/${id}`, data);
  }
  delete(id) {
    return axios.delete(`/preselections/${id}`);
  }
  // deleteAll() {
  //     return http.delete(`/requesting`);
  // }
  // findByTitle(titre) {
  //     return http.get(`/requesting?titre=${titre}`);
  // }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new PreselectionService();
